export default {"src":"/_next/static/media/InteractiveViewIcon.6fc2d555.svg","height":17,"width":17};